import React from "react"
import PropTypes from "prop-types"
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FilledInput,
} from "@mui/material"

const UNITS = ["pa", "m", "ml", "m²", "m³", "ud", "kg", "t"]
const EXTRA_UNITS = ["l", "h"]

const UnityDropdownMUI = ({ unity, setUnity, imDesglose, disabled, label }) => {
  const options = imDesglose ? [...UNITS, ...EXTRA_UNITS] : UNITS

  return (
    <FormControl
      fullWidth
      variant="filled"
      size="small"
      disabled={disabled}
      sx={{
        backgroundColor: "white",
        "& .MuiFilledInput-root": {
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
        "& .MuiFilledInput-root:before": { borderBottom: "none" },
        "& .MuiFilledInput-root:after": { borderBottom: "none" },
      }}
    >
      {label && <InputLabel shrink>{label}</InputLabel>}
      <Select
        value={unity}
        onChange={e => setUnity(e.target.value)}
        input={<FilledInput disableUnderline />}
        displayEmpty
      >
        {options.map(unit => (
          <MenuItem key={unit} value={unit}>
            {unit}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

UnityDropdownMUI.propTypes = {
  unity: PropTypes.string,
  setUnity: PropTypes.func.isRequired,
  imDesglose: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
}

UnityDropdownMUI.defaultProps = {
  unity: "",
  imDesglose: false,
  disabled: false,
  label: "",
}

export default UnityDropdownMUI
